module.exports = __webpack_public_path__ + "img/187.6f243181.png";